import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

class SubNav extends Component {
    constructor(props) {
        super(props);
        this.eventDetailsLink = '/event/event-details';
        this.purchaseRequestLink = '/event/purchase-request';
        this.afterActionLink = '/event/after-action';
    }

    render() {
        let purchaseRequestClasses = 'event__parent-link is-disabled';
        if (this.props.prAccessible) {
            purchaseRequestClasses = 'event__parent-link';
        }

        let hasAfterAction = false;
        const now = moment();
        if (
            this.props.status === 'Approved' &&
            this.props.startDate &&
            this.props.startDate.isSameOrBefore(now)
        ) {
            hasAfterAction = true;
        }

        let afterActionClasses = 'event__parent-link is-disabled';
        if (hasAfterAction) {
            afterActionClasses = 'event__parent-link';
        }
        return (
            <nav className="event__parent-nav">
                <ul className="event__parent-list">
                    <li className="event__parent-list-item">
                        <NavLink
                            activeClassName="is-active"
                            className="event__parent-link"
                            to={this.eventDetailsLink}
                        >
                            Event Details
                        </NavLink>
                    </li>

                    <li className="event__parent-list-item ">
                        <NavLink
                            activeClassName="is-active"
                            className={purchaseRequestClasses}
                            to={this.purchaseRequestLink}
                        >
                            Purchase Request
                        </NavLink>
                    </li>

                    <li className="event__parent-list-item ">
                        <NavLink
                            activeClassName="is-active"
                            className={afterActionClasses}
                            to={this.afterActionLink}
                        >
                            After Action
                        </NavLink>
                    </li>
                </ul>
            </nav>
        );
    }
}

export default SubNav;



// WEBPACK FOOTER //
// ./src/components/event/sub-nav/index.js